import React, { Component } from "react"
import PropTypes from "prop-types"
import { withRadium } from "higher-order-components"
import { connect } from "react-redux"
import COLOR_PALETTE from "constants/color-palette"
import { Section, BackButton } from "AtomicComponents"
import { actionCreators } from "store/actions/mymazda"
import FlashMessageBanner from "./navigation/flash-message-banner"

class MyMazdaWrapper extends Component {
  componentDidMount() {
    const { onLoadMessage } = this.props
    if (onLoadMessage && onLoadMessage.message) {
      this.props.addFlashMessage(onLoadMessage.message, onLoadMessage.type || "SUCCESS", 0)
    }
  }
  render() {
    const { children, backButton = false } = this.props
    return (
      <div>
        <div style={styles.flashWrapper}>
          <FlashMessageBanner />
        </div>
        {
          backButton &&
          <BackButton
            href={"javascript:history.back()"}
            backText="Go back"
          />
        }
        <Section padding backgroundColor="#ffffff">
          {children}
        </Section>
      </div>
    )
  }
}

const styles = {
  flashWrapper: {
    position: "absolute",
    left: 0,
    right: 0,
    width: "100%",
    zIndex: "1"
  },
  backLink: {
    position: "absolute",
    textAlign: "left",
    top: "-6em",
    left: "0",
    padding: "2em",
    fontSize: "13px",
    letterSpacing: "0.2em",
    textTransform: "uppercase",
    fontWeight: 600,
    lineHeight: "1.2",
    textDecoration: "none",
    cursor: "pointer",
    color: COLOR_PALETTE.GRAY_DARK,
    transition: "color .25s",
    ":hover": {
      color: COLOR_PALETTE.GRAY_DARKER
    }
  }
}

MyMazdaWrapper.propTypes = {
  children: PropTypes.node,
  backButton: PropTypes.bool,
  onLoadMessage: PropTypes.string,
  addFlashMessage: PropTypes.func
}

const mapDispatchToProps = dispatch => ({
  addFlashMessage: (...args) => dispatch(actionCreators.addFlashMessage(...args))
})

export default withRadium(connect(null, mapDispatchToProps))(MyMazdaWrapper)



// WEBPACK FOOTER //
// ./src/containers/mymazda/wrapper.jsx